import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-column-first" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "card-hold-details-row" }
const _hoisted_4 = { class: "card-hold-details-row" }
const _hoisted_5 = { class: "hold-row-value" }
const _hoisted_6 = { class: "card-hold-details-row" }
const _hoisted_7 = { class: "hold-row-value word-break" }
const _hoisted_8 = { class: "card-hold-details-row" }
const _hoisted_9 = { class: "hold-row-value" }
const _hoisted_10 = { class: "card-hold-details-row" }
const _hoisted_11 = { class: "hold-row-value" }
const _hoisted_12 = { class: "card-hold-details-row" }
const _hoisted_13 = { class: "hold-row-value" }
const _hoisted_14 = { class: "card-hold-details-row" }
const _hoisted_15 = { class: "hold-row-value" }
const _hoisted_16 = { class: "card-hold-details-row" }
const _hoisted_17 = { class: "hold-row-value" }
const _hoisted_18 = { class: "card-hold-details-row" }
const _hoisted_19 = { class: "hold-row-value" }
const _hoisted_20 = { class: "card-hold-details-row card-hold-details-row--status" }
const _hoisted_21 = { class: "hold-row-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[10] || (_cache[10] = _createElementVNode("h3", { class: "card-title-bold" }, "Lot Details", -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "hold-row-title" }, "Lot No.", -1)),
        _createVNode(_component_router_link, {
          class: "link-with-hover hold-row-value",
          to: `/lots/stage/${$setup.props.stage._id}/lot/${$setup.lot._id}/actions`
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($setup.lot.title), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "hold-row-title" }, "Street Name", -1)),
        _createElementVNode("div", _hoisted_5, _toDisplayString($setup.lot.streetName || "--"), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "hold-row-title" }, "Stage", -1)),
        _createElementVNode("div", _hoisted_7, _toDisplayString($setup.props.stage.title), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "hold-row-title" }, "Block Width", -1)),
        _createElementVNode("div", _hoisted_9, _toDisplayString($setup.zeroCheck($setup.formatNumbers($setup.lot.blockWidth, false), " m")), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "hold-row-title" }, "Block Depth", -1)),
        _createElementVNode("div", _hoisted_11, _toDisplayString($setup.zeroCheck($setup.formatNumbers($setup.lot.blockDepth, false), " m")), 1)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "hold-row-title" }, "Size", -1)),
        _createElementVNode("div", _hoisted_13, _toDisplayString($setup.formatNumbers($setup.lot.size, false)) + " sqm", 1)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "hold-row-title" }, "Release Date", -1)),
        _createElementVNode("div", _hoisted_15, _toDisplayString($setup.lot?.releaseDate ? $setup.formatDate($setup.lot.releaseDate) : "-"), 1)
      ]),
      _createElementVNode("div", _hoisted_16, [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "hold-row-title" }, "Registration Date", -1)),
        _createElementVNode("div", _hoisted_17, _toDisplayString($setup.lot?.registrationDate ? $setup.formatDate($setup.lot.registrationDate) : "-"), 1)
      ]),
      _createElementVNode("div", _hoisted_18, [
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "hold-row-title" }, "Price", -1)),
        _createElementVNode("div", _hoisted_19, _toDisplayString($setup.formatNumbers($setup.lot.price)), 1)
      ]),
      _createElementVNode("div", _hoisted_20, [
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "hold-row-title" }, "Current Status", -1)),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", {
            class: _normalizeClass(["badge", $setup.getLotStatusStyle($setup.lot.status)])
          }, _toDisplayString($setup.lotStatusText), 3)
        ])
      ])
    ])
  ]))
}